
      export default {
        functional: true,
        render: 
      function render(_h, _vm) {
        var _c=_vm._c;return _c('svg',{class:[_vm.data.class, _vm.data.staticClass],style:([_vm.data.style, _vm.data.staticStyle]),attrs:{"xmlns":"http://www.w3.org/2000/svg","width":"34","height":"26"}},[_c('g',{attrs:{"stroke":"#FFF","fill":"none","fill-rule":"evenodd"}},[_c('path',{attrs:{"d":"M13.02 9.412c1.488 0 2.706-1.218 2.706-2.706S14.508 4 13.02 4s-2.706 1.218-2.706 2.706 1.218 2.706 2.706 2.706h0z"}}),_c('path',{attrs:{"stroke-linecap":"round","stroke-linejoin":"round","d":"M21.465 21.364c-1.258-6.164-4.169-9.246-8.732-9.246C8.21 12.118 5.3 15.2 4 21.364h17.465z"}}),_c('path',{attrs:{"d":"M19.589 10.314h11.726M19.589 4.902h11.726M.5 24.5l33-23"}})])])
      }
    
      }
    